import React, { Fragment, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useFlexLayout } from "react-table";
import ReactTableConstructor from "./components/ReactTableConstructor";
import ReactTableCell from "./components/ReactTableCell";
import ReactTableCellEditable from "./components/ReactTableEditableCell";
import { prototype } from "react-smooth-scrollbar";

const ReactTableBase = ({
  tableConfig,
  columns,
  data,
  updateDraggableData,
  updateEditableData,
  refresh,
  handleValue,
}) => {
  const {
    isEditable,
    isResizable,
    isSortable,
    withDragAndDrop,
    withPagination,
    withSearchEngine,
    manualPageSize,
    indexPageForm,
    handlerIndexPage,
    autoResetPage,
    skipPageReset,
  } = tableConfig;

  const [filterValue, setFilterValue] = useState("");

  useEffect(() => {
    handleValue(filterValue);
  }, [filterValue]);

  const tableOptions = {
    columns,
    data,
    updateDraggableData,
    updateEditableData,
    setFilterValue,
    defaultColumn: {},
    isEditable,
    withDragAndDrop: withDragAndDrop || false,
    dataLength: data.length,
    autoResetPage: skipPageReset !== undefined ? skipPageReset : false,
    disableSortBy: !isSortable,
    manualSortBy: !isSortable,
    manualGlobalFilter: !withSearchEngine,
    manualPagination: !withPagination,
    handlerIndexPage,
    initialState: {
      pageIndex: indexPageForm !== undefined ? indexPageForm : 0,
      pageSize: manualPageSize ? manualPageSize[0] : 10,
      globalFilter: withSearchEngine && filterValue ? filterValue : "",
    },
  };

  let tableOptionalHook = [];
  if (isResizable) tableOptionalHook = [useFlexLayout];
  if (withSearchEngine) {
    tableOptions.defaultColumn = {
      Cell: ReactTableCell,
    };
  }
  if (isEditable) {
    tableOptions.defaultColumn = {
      Cell: ReactTableCellEditable,
    };
  }

  return (
    <ReactTableConstructor
      key={isResizable || isEditable ? "modified" : "common"}
      tableConfig={tableConfig}
      tableOptions={tableOptions}
      tableOptionalHook={tableOptionalHook}
      refresh={refresh}
    />
  );
};

ReactTableBase.propTypes = {
  tableConfig: PropTypes.shape({
    isEditable: PropTypes.bool,
    isResizable: PropTypes.bool,
    isSortable: PropTypes.bool,
    withDragAndDrop: PropTypes.bool,
    withPagination: PropTypes.bool,
    withSearchEngine: PropTypes.bool,
    manualPageSize: PropTypes.arrayOf(PropTypes.number),
    placeholder: PropTypes.string,
    useActions: PropTypes.bool,
    actions: PropTypes.any,
  }),
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      name: PropTypes.string,
    })
  ),
  data: PropTypes.arrayOf(PropTypes.shape()),
  updateDraggableData: PropTypes.func,
  updateEditableData: PropTypes.func,
  handleValue: PropTypes.func,
};

ReactTableBase.defaultProps = {
  tableConfig: {
    isEditable: false,
    isResizable: false,
    isSortable: false,
    withDragAndDrop: false,
    withPagination: false,
    withSearchEngine: false,
    manualPageSize: [],
  },
  columns: [],
  data: [],
  updateDraggableData: () => {},
  updateEditableData: () => {},
  handlerIndexPage: () => {},
  handleValue: () => {},
};

export default ReactTableBase;
